import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import StyledContainer from "./style";

import { validateGap } from "../../../../helper";

import { faArrowDown, faArrowUp } from "@fortawesome/free-solid-svg-icons";

const LabelGap = ({ gap = 0 }) =>
  gap < 0 ? (
    <StyledContainer className="down">
      {Math.round(validateGap(gap) * 100) / 100}%
      <FontAwesomeIcon icon={faArrowDown} />
    </StyledContainer>
  ) : (
    <StyledContainer className="up">
      {Math.round(validateGap(gap) * 100) / 100}%
      <FontAwesomeIcon icon={faArrowUp} />
    </StyledContainer>
  );

export default LabelGap;
